/* global FWP */
import enquire from 'enquire.js/dist/enquire.min';

const componentWrap = $('.c-facetwp-filter-main');

if (componentWrap.length !== 0) {
    // categories facet at the top
    $(document).on('facetwp-loaded', function () {
        const allFilter = $('.c-facetwp-filter-main__all'),
            facetRadios = $('.c-facetwp-filter-main .facetwp-radio');

        // Make sure the 'All' label stays after interacting with filter
        //console.log('blog facetwp-loaded');
        allFilter.text(componentWrap.data('category-all'));

        // unselect all filter if another filter is selected
        facetRadios.each(function () {
            if ($(this).hasClass('checked')) {
                allFilter.removeClass('checked');
            }
        });

        // add checked class to the all filter when it is clicked on
        allFilter.on('click', function () {
            $(this).addClass('checked');
        });

        // when another category than 'all' is clicked on deselect the all filter
        facetRadios.on('click', function () {
            allFilter.removeClass('checked');
        });
    });

    enquire.register('screen and (max-width: 767px)', {
        match: function () {
            const facetCategories = $('.facetwp-type-radio'),
                dropDown = $('.c-facetwp-filter-main__dropdown');

            facetCategories.css('display', 'none');
            dropDown.removeClass('open');
            dropDown.click(function () {
                facetCategories.toggle();
                dropDown.toggleClass('open');
            });
        },
        unmatch: function () {
            const facetCategories = $('.facetwp-type-radio'),
                dropDown = $('.c-facetwp-filter-main__dropdown');

            facetCategories.css('display', 'inline-flex');
            dropDown.removeClass('open');
        },
    });

    $(document).on('facetwp-refresh', function () {
        const facetCategories = $('.facetwp-type-radio'),
            dropDown = $('.c-facetwp-filter-main__dropdown');

        if (FWP.loaded) {
            // Add 'Loading' message
            $('.facetwp-template').prepend('<div class="facetwp-loading"><div class="facetwp-loading-text">Loading</div></div>');
        }
        // If smaller screen, close category dropdown after category select
        if ($(window).width() < 768) {
            facetCategories.css('display', 'none');
            dropDown.removeClass('open');
        }
    });
}



// WEBPACK FOOTER //
// ./scripts/routes/components/facetwp-filter-main.js